import PACaseDraftAccessForm from "@/components/PACaseDraftAccess/PACaseDraftAccessForm";
import { Title } from "capitalrx-components-2.0/lib/typography/Title";
import { FC, useCallback, useState } from "react";
import { FieldValues } from "react-hook-form";
import { getPACaseDraftAPI } from "@/api/get";
import { PACaseDraftGetRequest, PACaseDraftResponse } from "@/api/interfaces/PACaseDraft";
import { PACaseDraftQuestionnaire } from "@/components/PACaseDraftQuestionnaire";
// import { PACaseDraftQuestionnaire } from "@/components/PACaseDraftQuestionnaire";


export const PACaseDraftAccessPage: FC = () => {

    const [errorVisible, setErrorVisible] = useState<boolean>(false);
    const [caseDraft, setCaseDraft] = useState<PACaseDraftResponse | null>(null);

    const caseDraftFormSubmitHandler = useCallback(async (formValues: FieldValues) => {
      try {
        setErrorVisible(false);

        const request: PACaseDraftGetRequest = {
          unique_code: formValues.unique_code,
          patient_date_of_birth: formValues.patient_date_of_birth,
          patient_last_name: formValues.patient_last_name,
        };

        const response = await getPACaseDraftAPI(request);
        setCaseDraft(response);

      } catch {
        setErrorVisible(true);

      }
    }, []);

  return caseDraft ? (
    <div>
      <PACaseDraftQuestionnaire paCaseDraft={caseDraft}/>
    </div>
  ) : (
    <div>
      <Title>Authenticate To Access Prior Authorization Case Draft</Title>
      <PACaseDraftAccessForm errorVisible={errorVisible} submitHandler={caseDraftFormSubmitHandler}/>
    </div>
  );
};

export default PACaseDraftAccessPage;
